import React from 'react'
// containers
import LocationsContainer from 'containers/Locations'

const LocationsPage: React.FC = () => <LocationsContainer />

export default LocationsPage
